import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('SynergyNode Error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', background: '#060b18', display: 'flex',
          alignItems: 'center', justifyContent: 'center', padding: 24,
          fontFamily: 'Arial, sans-serif'
        }}>
          <div style={{
            background: '#0d1528', border: '1px solid rgba(239,68,68,0.3)',
            borderRadius: 16, padding: 32, maxWidth: 480, width: '100%',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: 40, marginBottom: 16 }}>⚠️</div>
            <h2 style={{ color: '#f87171', margin: '0 0 12px', fontSize: 18 }}>
              Something went wrong
            </h2>
            <p style={{ color: '#475569', fontSize: 14, margin: '0 0 20px' }}>
              {this.state.error?.message || 'An unexpected error occurred'}
            </p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
              <button
                onClick={() => { this.setState({ hasError: false, error: null }); }}
                style={{ background: 'rgba(59,130,246,0.2)', border: '1px solid rgba(59,130,246,0.4)', color: '#60a5fa', padding: '8px 20px', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>
                Try Again
              </button>
              <button
                onClick={() => { localStorage.clear(); window.location.href = '/login'; }}
                style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', color: '#94a3b8', padding: '8px 20px', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>
                Clear & Re-login
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
